export default {

    changeDateFormat(date){

        if(this.isNullOrEmpty(date) || date == "null") { return "-" }

        if(date) {

            const month_names = [
                "Januari", "Februari", "Maret",
                "April", "Mei", "Juni",
                "Juli", "Agustus", "September",
                "Oktober", "November", "Desember"
            ];

            let year = date.slice(0, 4);
            let month = date.slice(5, 7);
            let day = date.slice(8, 10);
            let dayInt = parseInt(day, 10);
            let monthInt = parseInt(month, 10);

            return `${dayInt} ${month_names[monthInt-1]} ${year}`;
            
        }

        return '-';

    },

    changeDateFormatGetHour(date) {
        if(date){
            let clock = date.slice(11, 16)
            return `${clock}`;
        }
        return '-';
    },
    
    addThousandSeparator(number){
        // const rounded =  Math.round(number * 100) / 100;
        if(number == 0) { return 0 }

        if(number){
            return `${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
        }
        
        return '-';

    },

    removeThousandSeparator(num){
        if(num){
            let removeDotNum = ("" + num).replace(/\./g, "");
            if(isNaN(removeDotNum)){
                return ""
            }else{
                return Number(removeDotNum);
            }
        } else if(num == 0) return 0

        return "";
    },

    changeToValue(num){
        if(num){
            let removeDotNum = num.replace(/\./g, "");
            return removeDotNum;
        }
        return ""
    },

    makeQuery(page, size){
        let string = "?page="+page+"&size="+size
        return string
    },

    getAllCabang(){
        let getCabang = localStorage.getItem("cabang")
        let allCabang = JSON.parse(getCabang)
        return allCabang
    },

    getCabangId(){
        return localStorage.getItem("activeCabangId")
    },

    setFlash(msg){
        localStorage.setItem('flash', msg)
    },

    getFlash(){
        let flash = localStorage.getItem('flash')
        localStorage.removeItem('flash')
        return flash
    },

    returnYears(){
        let currentYear = new Date().getFullYear()
        let arrYear = []
        let x = 2000
        while(x <= currentYear+2){
            arrYear.push(x)
            x++
        }
        return arrYear
    },

    createEmptyFile() {
        var f = new File([""], "blank.pgifile")
        return f
    },

    toastSucc(vue, msg, toastTitle='Sukses'){
        vue.$bvToast.toast(msg, {
          title: toastTitle,
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'success'
        })
    },

    toastErr(vue, msg, toastTitle='Gagal'){
        vue.$bvToast.toast(msg, {
            title: toastTitle,
            autoHideDelay: 5000,
            appendToast: true,
            variant: 'danger'
        })
    },

    parseError(vue, error, toastTitle = "Gagal") {

        console.log(error)

        let message = ""

        if(error.response && error.response.data.reason != null) {
            message = error.response.data.reason
        }
        else if(error.message.startsWith("timeout")) {
            message = "Gagal menghubungi server, periksa jaringan anda dan coba kembali! [ERR-TIMEOUT]"
        }
        else {
            message = error.message
        }

        this.toastErr(vue, message, toastTitle)

    },

    toastAlert(vue, msg, toastTitle='Alert'){
        vue.$bvToast.toast(msg, {
          title: toastTitle,
          autoHideDelay: 5000,
          appendToast: true,
          variant: 'primary'
        })
    },

    isNotNullAndNotEmpty(input) {
        return input != null && input != '' && input.length != 0
    },

    isNullOrEmpty(input) {
        return input == null || input == ''
    },

    printPayload(payload) {

        for(var pair of payload.entries()) {
            console.log(pair[0] + ': ' + pair[1]); 
        }

    },

    resizeImage(base64Str, maxWidth = 1920, maxHeight = 1080){
        
        return new Promise((resolve) => {
            // console.log(base64Str)
            console.log(base64Str.length)
            let img = new Image()
            img.src = base64Str
            img.onload = () => {
                let canvas = document.createElement('canvas')
                const MAX_WIDTH = maxWidth
                const MAX_HEIGHT = maxHeight
                let width = img.width
                let height = img.height

                if (width > height) {
                    if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width
                    width = MAX_WIDTH
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height
                    height = MAX_HEIGHT
                    }
                }
                canvas.width = width
                canvas.height = height
                let ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, width, height)
                let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)
                // console.log(newBase64Str)
                console.log(newBase64Str.length)
                if(newBase64Str.length < base64Str.length) {
                    resolve(newBase64Str)
                } else {
                    resolve(base64Str)
                }
            }
        })
    },

}